<template>
  <div>
    <a-spin :spinning="loading" >

    <div class="order">
      
      <div class="grid-content bg-purple">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-daichuli" />
        </svg>
        <span class="p_red" v-if="data.state == 2||data.state == 6||data.state == 88||data.state == 99">{{ stateDesc }}</span>
        <span class="blue" v-else>{{ stateDesc }}</span>
        <div v-if="data.state == 33" class="p_red">
          保费将在1-5个工作日原路退回
        </div>
        <!-- <div v-if="data.state == 7" class="p_red">{{ data.remark }}</div> -->
        <div v-if="data.state == 32" class="p_red">
          {{ data.cancelMessage }}
        </div>
      </div>
      <div class="grid-content bg-purple-light">
        <div class="content_head">
          <span>保函编号：</span>
          <span>{{ data.policySn||'-' }}</span
          ><br />
          <span>保证金：</span>
          <span class="blue">￥{{ thousandCentimeter(data.sumMargin) }}元</span>
        </div>
        <div class="content_head">
          <span>订单时间：</span>
          <span>{{ dateFormat(data.createTime) }}</span
          >
          <br />
          <span>保费总计</span>
          <h3>￥{{ thousandCentimeter(data.sumPremium) }}元</h3>
        </div>
        <div class="content_head" v-if="data.bidStartDate">
          <span>起保日期：</span>
          <span>{{ dateFormat(data.bidStartDate) }}</span
          >
          <br />
          <span>终保日期</span>
          <span>{{ dateFormat(data.bidEndDate) }}</span>
        </div>
        <div>
          <div>
            <button
              class="custom-btn btn-4"
              @click="goBtn(isBtnStr)"
              v-if="isVisBtn"
            >
              <span>{{ isBtnStr }}</span>
            </button>
          </div>
        </div>
        <!-- <a-button
          v-if="data.state==3"
          class="downloadBtn"
          @click="download"
        >
          下载保函
        </a-button> -->
      </div>
      
    </div>
    <div v-if="data.state == 21" class="p_tip">
      温馨提示：请仔细校对保函信息是否与招标文件一致，如信息有误请及时拨打客服电话！
    </div>

    <PlateTitle title="投保信息">
      <template v-slot:extra>
        <div class="reding">
          <span>阅读<a @click="rulesShow = true">《投保须知》</a> </span>
        </div>
      </template>
    </PlateTitle>

    <div class="main">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <!-- <a-form-item label="保函编号" has-feedback v-if="data.policySn">
          <span>{{ data.policySn }}</span>
        </a-form-item> -->
        <!--  -->
        <a-form-item label="出函机构" has-feedback>
          <div>{{ data.institutionName }}</div>
          <!-- <div class="logo_box">
            <img  :src="'data:image/png;base64,'+ data.partnerLogoPathBase64" />
          </div> -->
        </a-form-item>
       
        <a-form-item label="项目名称" has-feedback>
          <span>{{ data.projectName }}</span>
        </a-form-item>
        <a-form-item label="项目编号" has-feedback>
          <span>{{ data.projectCode }}</span>
        </a-form-item>
        <a-form-item label="标段名称" has-feedback>
          <span>{{ data.sectionName }}</span>
        </a-form-item>
        <a-form-item label="标段编号" has-feedback>
          <span>{{ data.sectionCode }}</span>
        </a-form-item>
        <a-form-item label="受益人名称" has-feedback>
          <span>{{ data.beneficiary }}</span>
        </a-form-item>
        <a-form-item label="受益人统一社会信用代码" has-feedback>
          <span>{{ data.beneficiaryCreditCode }}</span>
        </a-form-item>
        <a-form-item label="受益人联系电话" has-feedback>
          <span>{{ data.beneficiaryPhone }}</span>
        </a-form-item>
        <a-form-item label="受益人注册地址" has-feedback>
          <span>{{ data.beneficiaryRegisteredAddress }}</span>
        </a-form-item>
        <a-form-item label="中标金额" has-feedback>
          <span class="blue">{{ thousandCentimeter(data.bidPrice) }}元</span>
        </a-form-item>
        <a-form-item label="担保金额" has-feedback>
          <span class="blue">{{ thousandCentimeter(data.sumAmount) }}元</span>
        </a-form-item>
        <!--  -->
        <a-form-item label="担保类型" has-feedback>
          <span>{{ data.productName }}</span>
        </a-form-item>
        <a-form-item label="担保截止日期" has-feedback v-if="data.guaranteePeriodType == 3">
          <span>{{ dateFormat(data.guaranteeEndDate) }}</span>
        </a-form-item>
        <a-form-item label="期限（月/天）" has-feedback v-if="data.guaranteePeriodType == 1||data.guaranteePeriodType == 2">
          <span>{{ data.guaranteePeriod  }}</span>
          <span v-if="data.guaranteePeriodType == 1">天</span>
          <span v-if="data.guaranteePeriodType == 2">月</span>
        </a-form-item>
        <a-form-item label="是否已签署合同" has-feedback >
          <span v-if="data.isSignContract == 1">是</span>
          <span v-if="data.isSignContract == 0">否</span>
        </a-form-item>
        <a-form-item label="工期开始时间" has-feedback v-if="data.guaranteePeriodType == 3">
          <span>{{ dateFormat(data.durationStartDate) }}</span>
        </a-form-item>
        <a-form-item label="工期结束时间" has-feedback v-if="data.guaranteePeriodType == 3">
          <span>{{ dateFormat(data.durationEndDate) }}</span>
        </a-form-item>

        <a-form-item label="项目性质" has-feedback>
          <span>{{ data.projectNatureDesc }}</span>
        </a-form-item>
        <a-form-item label="最高等级资质" has-feedback>
          <span>{{ data.maxAptitudeLevelDesc }}</span>
        </a-form-item>
        <a-form-item label="企业名称" has-feedback>
          <span>{{ data.enterpriseName }}</span>
        </a-form-item>
        <a-form-item label="企业统一社会信用代码" has-feedback>
          <span>{{ data.creditCode }}</span>
        </a-form-item>
        <a-form-item label="企业注册地址" has-feedback>
          <span>{{ data.registeredAddress }}</span>
        </a-form-item>
        <a-form-item label="法人名称" has-feedback>
          <span>{{ data.legalName }}</span>
        </a-form-item>
        <a-form-item label="联系方式" has-feedback>
          <span>{{ data.bidderPhone }}</span>
        </a-form-item>
        <a-form-item label="经办人姓名" has-feedback>
          <span>{{ data.customerContact }}</span>
        </a-form-item>
        <a-form-item label="经办人电话" has-feedback>
          <span>{{ data.handlePhone }}</span>
        </a-form-item>
         <!--<a-form-item label="经办人" has-feedback>
          <span>{{ data.responsiblePersonName }}</span>
        </a-form-item>
        <a-form-item label="经办人联系方式" has-feedback>
          <span>{{ data.responsiblePersonPhone }}</span>
        </a-form-item> -->
      </a-form>
    </div>
    <template
      v-if="data.state == '3' || data.state == '5' || data.state == '6'|| data.state == '7'|| data.state == '8'"
    >
      <PlateTitle title="支付信息">
      </PlateTitle>
      <div class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="保费凭证" has-feedback v-for="(item, index) in premiumVoucherList">
            <!-- <span>{{ item.filePath }}</span> -->
            <img class="VoucherImg" :src="'/api/contract/downloadView?source='+ item.filePath" alt="" />
          </a-form-item>
          <a-form-item label="保证金凭证" has-feedback v-for="(item, index) in marginVoucherList">
              <!-- <span>{{ item.filePath }}</span> -->
              <img class="VoucherImg" :src="'/api/contract/downloadView?source='+ item.filePath" alt="" />
          </a-form-item>
        </a-form>
      </div>
    </template>
<!-- 
    <template v-if="data.state == 21 && (data.invoiceStatus == 20 || data.invoiceType == 2)">
      <PlateTitle title="发票信息" subtitle="（发票1-5个工作日内开具）">
        <template v-slot:extra>
          <a-button
            v-if="data.invoiceUrl"
            type="primary"
            @click="goBtn('下载发票')"
          >
            下载发票
          </a-button>
        </template>
      </PlateTitle>
      <div class="main" v-if="data.invoiceType == 3 && data.invoiceStatus == 20">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="开票类型" has-feedback>
            <span>{{ data.invoiceTypeStr }}</span>
          </a-form-item>
          <a-form-item label="快递公司" has-feedback>
            <span>{{ data.expressName }}</span>
          </a-form-item>
          <a-form-item label="电子邮箱" has-feedback>
            <span>{{ data.expressNo }}</span>
          </a-form-item>
        </a-form>
      </div>
      <div v-if='data.invoiceType == 2' class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="开票类型" has-feedback>
            <span>{{ data.invoiceTypeStr }}</span>
          </a-form-item>
          <a-form-item label="发票抬头" has-feedback>
            <span>{{ data.invoiceHead }}</span>
          </a-form-item>
          <a-form-item label="纳税人识别号" has-feedback>
            <span>{{ data.invoiceCuscCode }}</span>
          </a-form-item>
          <a-form-item label="电子邮箱" has-feedback>
            <span>{{ data.invoiceEmail }}</span>
          </a-form-item>
        </a-form>
      </div>
    </template>

    <template
      v-if="
        data.state === '31' || data.state === '32' || data.state === '33'
      "
    >
      <PlateTitle title="退款信息" />
      <div class="main">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="退款账户" has-feedback>
            <span>{{ data.cancelAccountName }}</span>
          </a-form-item>
          <a-form-item label="退款账号" has-feedback>
            <span>{{ data.cancelBankNo }}</span>
          </a-form-item>
        </a-form>
      </div>
    </template>

    <a-modal
      v-model="visible"
      :title="isBtnStr"
      @ok="submit"
      :mask-closable="false"
      ok-text="确认"
      cancel-text="取消"
      class="Invoicing"
    >
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="手机号" v-if="isBtnStr !== '开票'">
          <span>{{ data.mobile }}</span>
        </a-form-item>
        <div v-if="isBtnStr === '退保'">
          <a-form-item label="验证码" class="code" v-if="step === 0">
            <a-input
              v-decorator="[
                'code',
                { rules: [{ required: true, message: '请输入验证码' }] }
              ]"
              placeholder="请输入验证码"
              style="width: 275px"
            />
            <img :src="codeImg" alt="" @click="code" />
          </a-form-item>
          <a-form-item label="短信验证码" class="code" v-if="step === 0">
            <a-input
              v-decorator="[
                'phoneCode',
                { rules: [{ required: true, message: '请输入短信验证码' }] }
              ]"
              placeholder="请输入短信验证码"
              style="width: 275px"
            />
            <a v-if="isTime" @click="phoneCode">获取验证码</a>
            <span v-else>{{ time }}s重新获取</span>
          </a-form-item>

          <a-form-item label="退保原因">
            <a-select
              v-decorator="[
                'cancelReason',
                { rules: [{ required: true, message: '请选择退保原因' }] }
              ]"
              style="width: 275px"
            >
              <a-select-option value="项目未开标，不想投标了">
                项目未开标，不想投标了
              </a-select-option>
              <a-select-option value="投标人失误，或选择投标项目错误">
                投标人失误，或选择投标项目错误
              </a-select-option>
              <a-select-option value="因项目变化等其他原因">
                因项目变化等其他原因
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div v-if="isBtnStr === '开票'">
          <a-form-item label="发票抬头">
            <span>{{ data.invoiceHead }}</span>
          </a-form-item>
          <a-form-item label="纳税人识别号">
            <span>{{ data.creditCode }}</span>
          </a-form-item>
          <a-form-item label="手机号">
            <span>{{ data.mobile }}</span>
          </a-form-item>
          <a-form-item label="发票类型">
            <a-select v-model="invoiceType" style="width: 275px">
              <a-select-option
                v-for="(item, index) in typeArray"
                :key="index"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="邮箱">
            <a-input
              v-decorator="[
                'email',
                { rules: [{ required: true, message: '请输入邮箱' }] }
              ]"
              placeholder="请输入邮箱"
              style="width: 275px"
            />
          </a-form-item>
          <a-form-item label="备注">
            <a-input
              type="textarea"
              v-decorator="['remark', { rules: [{}] }]"
              placeholder="请输入备注"
              style="width: 275px"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
 -->
    <div class="notice-dialog">
      <a-modal
        class="rules"
        v-model="rulesShow"
        title="支付须知"
        centered
        :mask-closable="false"
        :closable="false"
        @cancel="
          () => {
            rulesShow = false;
          }
        "
        @ok="
          () => {
            rulesShow = false;
          }
        "
      >
        <div class="content">
          <h2>关于退订说明</h2>
          <p>
            1.覆约保函审核通过后，订单不可退订。 <br>2.如有疑问可咨询企业微信客服或拨打服务热线：13856990809
          </p>
          <h2>平台声明</h2>
          <p>
            1.本平台仅提供技术支持和运营服务。 <br> 2.保函审核，出函，退费流程均按所选服务机构要求执行。
          </p>
        </div>
        <template v-slot:footer>
          <a-button @click="rulesShow = false" type="primary">
            我知道了
          </a-button>
        </template>
      </a-modal>
    </div>
    <div class="notice-dialog">
      <a-modal
        class="polic"
        v-model="policyShow"
        title="退保申请"
        centered
        :mask-closable="false"
        :closable="true"
        @cancel="policyShow = false"
      >
        <div class="contents">
          退保需要填写退保申请书，申请书及当时付款的凭证需盖章
          后邮寄至：深圳市福田区莲花街道福新社区益田路6013号江苏大厦A、B座A座17层1702 李经理 17788782725
          <div>
            <div class="down">
              点击下载
              <a
                href="/api/insure/index/download?type=refund_application_template"
                target="_blank"
                >《退保申请书模板》
              </a>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <a-button size="large" type="primary" @click="policyShow = false"
            >我知道了</a-button
          >
        </template>
      </a-modal>
    </div>
  </a-spin>

  </div>
</template>

<script>
import PlateTitle from "@/components/PlateTitle";
import { getInformation } from "@/api/nonBidInsure.js";
import { dateFormat } from '@/utils/format.js';
import { dictDetail } from '@/api/performance.js';
import {
  code,
  phoneCode,
  insureCancel,
  insureInvoice,
  certType,
  getDictInfo,
} from "@/api/nonBidInsure.js";
// const querystring = require('querystring');
export default {
  name: "Step2",
  components: {
    PlateTitle
  },
  props: {
    step: {
      type: Number,
      default: 0
    },
    insureNotice: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading:false,
      dateFormat,
      data: {},
      orderCode: "",
      stateDesc: "",
      isBtnStr: "",
      isVisBtn: false,
      visible: false,
      rulesShow: false,
      policyShow: false,
      form: this.$form.createForm(this, { name: "form"}),
      uuid: "",
      codeImg: "",
      isTime: true,
      time: 60,
      // createDate: '',
      // 发票类型
      invoiceType: "",
      type: "",
      typeArray: [], //选择开票类型
      
      // 
      guaranteePeriodTypeList:[],
      projectNatureList:[],
      maxAptitudeLevelList:[],
      productList:[],
      premiumVoucherList:[], //保费
      marginVoucherList:[]
    };
  },
  mounted() {
    this.getInformation();
    this.code();
    this.orderCode = this.getQueryString("orderCode");
    this.type = window.localStorage.getItem("type");
    // getDictInfo("invoiceType").then(({ data: data }) => {
    //     this.typeArray = data.data;
    //   });
  },
  methods: {
    thousandCentimeter(value){
      if (!value) return '0.00';
      return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    getDictDetail() {
      dictDetail({ dictName: 'guaranteePeriodType' }).then(res => {
        this.guaranteePeriodTypeList = res.data.data;
      });
      dictDetail({ dictName: 'projectNature' }).then(res => {
        this.projectNatureList = res.data.data;
        this.projectNatureList.map(item=>{
          if(this.data.projectNature == item.value){
            this.data.projectNatureDesc = item.label
            this.$forceUpdate();
          }
        })
      });
      // 
      dictDetail({ dictName: 'maxAptitudeLevel' }).then(res => {
        this.maxAptitudeLevelList = res.data.data;
        this.maxAptitudeLevelList.map(item=>{
          if(this.data.maxAptitudeLevel == item.value){
            this.data.maxAptitudeLevelDesc = item.label
            this.$forceUpdate();
          }
        })
      });
      // dictDetail({ dictName: 'guaranteeAptitudeLevel' }).then(res => {
      //   this.guaranteeAptitudeLevelList = res.data.data;
      // });
      // dictDetail({ dictName: 'backletterFormat' }).then(res => {
      //   this.backletterFormatList = res.data.data;
      // });
      // dictDetail({ dictName: 'guaranteeProduct' }).then(res => {
      //   this.productList = res.data.data;
      // });
    },
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /* 图片验证码 */
    code() {
      code().then(res => {
        this.codeImg = res.img;
        this.uuid = res.uuid;
      });
    },
    /* 获取验证码 */
    phoneCode() {
      this.timer = "";
      console.log(this.form.instances);
      if (this.form.instances.code.stateValue !== "") {
        phoneCode({
          codeKey: this.uuid,
          code: this.form.instances.code.stateValue,
          phoneNum: this.data.mobile
        }).then(res => {
          if (res === "") {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning("图形验证码不为空");
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 60;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
    goBtn(type) {
      if (type === "支付") {
        window.open('/nonBidPayInfo?orderCode=' + this.data.orderCode);
      } else if (type === "下载保函") {
        if (navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1) {
          window.open(encodeURI(this.data.policyUrl), "_blank");
        }else{
          window.open(this.data.policyUrl, "_blank");
        }
      } else if (type === "退保") {
        this.visible = true;
      } else if (type === "开票") {
        // this.$refs.form.resetFields();
        this.visible = true;
        let that = this
        setTimeout(function () {
          that.form.setFieldsValue({
              email: that.data.invoiceEmail
            });
        },800)
      } else if (type === "下载发票") {
        window.open(this.data.invoiceUrl);
      }
    },
    submit() {
      let that = this
      this.form.validateFields(err => {
        if (!err) {
          if (this.isBtnStr === "退保") {
            const params = {
              responsiblePersonPhone: this.data.mobile,
              orderCode: this.orderCode,
              phoneCode: this.form.fieldsStore.fields.phoneCode.value,
              cancelReason: this.form.fieldsStore.fields.cancelReason.value
              // accountName: this.form.fieldsStore.fields.accountName.value,
              // bankName: this.form.fieldsStore.fields.bankName.value,
              // bankNo: this.form.fieldsStore.fields.bankNo.value,
            };
            console.log(params);
            insureCancel(params)
              .then(res => {
                console.log(res);
                if (res.status=== 200) {
                  this.$notification.success({ message: res.message });
                  this.getInformation();
                  this.visible = false;
                } else {
                  this.$notification.warning({ message: res.message });
                }
              })
              .catch(err => {
                this.$notification.error({ message: err.respomessage });
              });
          } else if (this.isBtnStr === "开票") {
            const paramsA = {
              responsiblePersonPhone: that.data.mobile,
              orderCode: that.orderCode,
              // phoneCode: that.form.fieldsStore.fields.phoneCode.value,
              invoiceType: that.invoiceType,
              // invoiceHead: that.form.fieldsStore.fields.invoiceHead.value,
              // cuscCode: that.form.fieldsStore.fields.cuscCode.value,
              invoiceHead: that.data.invoiceHead,
              cuscCode: that.data.creditCode,
              // bankInfo: that.form.fieldsStore.fields.bankInfo.value,
              // bankAcc: that.form.fieldsStore.fields.bankAcc.value,
              // phoneNo: that.form.fieldsStore.fields.phoneNo.value,
              // addInfo: that.form.fieldsStore.fields.addInfo.value,
              email: that.form.fieldsStore.fields.email.value,
              // addressee:that.form.fieldsStore.fields.addressee.value,
              // addresseePhone:that.form.fieldsStore.fields.addresseePhone.value,
              // email:that.form.fieldsStore.fields.email.value,
              // address:that.form.fieldsStore.fields.address.value,
              remark: that.form.fieldsStore.fields.remark.value,
              invoiceStatus: "0"
            };
            insureInvoice(paramsA).then(res => {
              if (res.data.status === 200) {
                this.$notification.success({ message: res.data.message });
                this.visible = false;
                this.getInformation();
              } else {
                this.$notification.warning({ message: res.data.message });
              }
            });
          }
        }
      });
    },
    // 下载
    download() {
    
      let url = "";
      // const data = this.data;
      // console.log(data.guaranteeStatus, 999111)
      // if (
      //   data.guaranteeStatus === "2" ||
      //   data.guaranteeStatus === "11" ||
      //   data.guaranteeStatus === "12"
      // ) {
      //   url = this.data.preSignDownloadUrl;
      // } else if (
      //   data.guaranteeStatus === "22" ||
      //   data.guaranteeStatus === "31" ||
      //   data.guaranteeStatus === "32"
      // ) {
      //   url = this.data.signDownloadUrl;
      // }
      if(this.data.signDownloadUrl) {
        url = this.data.signDownloadUrl
      } else {
        url = this.data.preSignDownloadUrl
      }
      window.open(encodeURI(url), "_blank");
    },
    getInformation() {
      let that = this
      this.orderCode = this.getQueryString("orderCode");
      this.loading = true
      getInformation({
        orderCode: this.orderCode
      }).then(response => {
        this.loading = false
        const res = response.data;
        // this.data = res.data;
        // debugger
        this.data = res;
        this.getDictDetail()

        console.log("===-", res);
        this.stateDesc = res.stateDesc;
        this.isVisBtn = true;
        // if (res.isInsureCancel && res.surrenderBut) {
        //   this.isBtnStr = "退保";
        // }
        // else if (res.isInsureInvoice && res.invoiceBut&&(that.data.thirdId==11||that.data.thirdId==26)) {
        //   this.isBtnStr = "开票";
        //   that.invoiceType = res.invoiceType
        // }
        // else 
        if (res.payEnable) {
          this.isBtnStr = "支付";
        }else if(res.state == '3'&& res.policyUrl){
          this.isBtnStr = "下载保函";
        } else {
          this.isVisBtn = false;
        }
        // if (res.invoiceUrl && res.invoiceBut&&(that.data.thirdId==11||that.data.thirdId==26)) {
        //   this.isBtnStr = "下载发票";
        //   this.isVisBtn = true;
        // }
        if(res.state == '3' || res.state == '5' || res.state == '6'|| res.state == '7'|| res.state == '8'){
          this.premiumVoucherList = [] //保费
          this.marginVoucherList = []
          res.fileList.map(item=>{
            if(item.category == '5'){
              this.premiumVoucherList.push({
                filePath:item.filePath
              })
            }
            if(item.category == '6'){
              this.marginVoucherList.push({
                filePath:item.filePath
              })
            }
          })

        }
        // if(res.state == "5"){
        //   // 审核中
        //   setTimeout(function(){
        //     that.getInformation()
        //   }, 4000)
        // }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.test {
  position: absolute;
  transform: translate(100px, -65px);
  color: #666;
}

.content_head {
  font-size: 18px;
  color: rgb(51, 51, 51);
}

.p_red {
  color: #ff0000;
  margin-top: 8px;
}

.p_tip {
  width: 100%;
  background: #f2f2f2;
  text-align: center;
  padding: 8px;
  margin-bottom: 10px;
}
.p_tips {
  width: 100%;
  height: 40px;
}

.icon {
  width: 8em;
  height: 8em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.logo_box {
  width: 100%;
  height: 94px;
  // background: red;
  img {
    max-width: 100%;
    height: 80%;
  }
}

.order {
  display: flex;
  align-items: center;
  margin: 20px 0 30px;

  .bg-purple {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      font-size: 20px;
    }

    a {
      font-size: 20px;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }

  .bg-purple-light {
    display: flex;
    flex: 3;

    h3 {
      color: #df263d;
    }

    div {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      div {
        display: flex;
        justify-content: center;
        // transform: translateY(100px);
      }
    }
  }

  .custom-btn {
    width: 130px;
    height: 40px;
    color: #fff;
    border-radius: 5px;
    padding: 10px 25px;
    font-family: "Lato", sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5),
      7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
    outline: none;
  }

  /* 4 */
  .btn-4 {
    // background-color: #4dccc6;
    // background-image: linear-gradient(315deg, #4dccc6 0%, #96e4df 74%);
    background: rgb(0, 172, 238);
    background: linear-gradient(
      0deg,
      rgba(0, 172, 238, 1) 0%,
      rgba(2, 126, 251, 1) 100%
    );
    line-height: 42px;
    padding: 0;
    border: none;
  }

  .btn-4:hover {
    // background-color: #89d8d3;
    // background-image: linear-gradient(315deg, #89d8d3 0%, #03c8a8 74%);
    background-color: rgb(0, 172, 238);
    background-image: linear-gradient(
      315deg,
      rgb(0, 172, 238) 0%,
      rgba(2, 126, 251, 1) 74%
    );
  }

  .btn-4:before,
  .btn-4:after {
    position: absolute;
    content: "";
    right: 0;
    top: 0;
    box-shadow: 4px 4px 6px 0 rgba(255, 255, 255, 0.9),
      -4px -4px 6px 0 rgba(116, 125, 136, 0.2),
      inset -4px -4px 6px 0 rgba(255, 255, 255, 0.9),
      inset 4px 4px 6px 0 rgba(116, 125, 136, 0.3);
    transition: all 0.3s ease;
  }

  .btn-4:before {
    height: 0%;
    width: 0.1px;
  }

  .btn-4:after {
    width: 0%;
    height: 0.1px;
  }

  .btn-4:hover:before {
    height: 100%;
  }

  .btn-4:hover:after {
    width: 100%;
  }
}

/deep/ .ant-row {
  //display: flex;
  //justify-content: center;
  display: inline-block;
  width: 49%;

}
/deep/ .ant-row .ant-form-item-label{
  width: 220px!important;
  padding-left: 10px !important;
}

/deep/ .ant-row .ant-col-18{
    display: inline-block;
    box-sizing: border-box;
    width: 60%;
}
/deep/ .ant-form-item {
  margin-bottom: 10px !important;
}

/deep/ .ant-form-item-control {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*加宽度width属来兼容部分浏览*/
}

.code {
  img {
    position: absolute;
    cursor: pointer;
    left: 180px;
    top: -5px;
    height: 30px;
  }

  a,
  span {
    position: absolute;
    width: 80px;
    left: 192px;
  }
}

.rules ::v-deep .ant-modal {
  width: 960px !important;
}

::v-deep .ant-modal-content {
  width: 960px !important;
  height: 716px !important;
  padding: 45px 50px;
  box-sizing: border-box;
}
.Invoicing ::v-deep .ant-modal-content {
  width: 700px !important;
}
::v-deep .ant-modal-body {
  padding: 24px 0 !important;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  text-align: center;
}

::v-deep .ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
}

.content {
  height: 392px;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
}
.contents {
  // height: 152px;
  padding: 20px;
  font-size: 18px;
}
::v-deep .ant-form-item-label {
  text-align: left !important;
  padding-left: 45px !important;
}

::v-deep .ant-form label {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.447);
}

::v-deep .ant-form-item-children {
  font-size: 14px;
  color: rgb(51, 51, 51);
}
.polic ::v-deep .ant-modal-content {
  width: 560px !important;
  height: 356px !important;
  padding: 15px 50px;
  box-sizing: border-box;
}
.polic {
  .down {
    margin-top: 10px;
    text-align: right;
  }
}


.downloadBtn {
  position: absolute;
  transform: translateX(900px);
  left:25px;
  top: 120px;
}
.blue{
  color: #125AFF!important;
  font-weight: 500;
  font-size: 20px;
}
.VoucherImg{
  height: 140px;
  width: 346px;
}
</style>

